<template>
  <div />
</template>

<script setup lang="ts">
import { computed } from "vue";

const values = {};
const disabledSubmit = computed(() => true);

defineExpose({
  values,
  disabledSubmit
});
</script>
